import { useState } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import { DateTime } from 'luxon'

const descriptionStyle = {display: 'flex', flexDirection: 'column', gap: 8}
const paragraphStyle = {margin: 0}
const errorStyle = {margin: 0, color: 'var(--destructive)', fontSize: 14, lineHeight: '20px'}

/*
  Confirma a remoção de um profissional da agenda, sobre o AlertDialog do @cutilei/ui. Espera a
  resposta antes de fechar: o Confirmar mostra o carregando, e um erro aparece dentro do diálogo.
  Enquanto a remoção corre, o Esc e o Cancelar não fecham.
*/
export default function RemoveProfessionalDialog({
  visible,
  title = 'Remover profissional da agenda',
  professional,
  notifyAbsence,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [removing, setRemoving] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const businessId = AuthService.getBusinessId()
  const firstName = professional.name.split(' ')[0]

  const removeProfessional = async () => {
    setRemoving(true)
    setErrorMessage(null)
    try {
      const currentDate = DateTime.now().toISODate()
      const endDate = DateTime.now().plus({years: 100}).toISODate()

      await cutileiApi.put(
        `/businesses/${businessId}/professionals/${professional.id}/activation`,
        {active: false},
        AuthService.getRequestAuth()
      )
      await notifyAbsence(currentDate, endDate)

      setRemoving(false)
      handleConfirm(professional)
      handleClose()
    } catch (error) {
      setRemoving(false)
      setErrorMessage(getApiErrorMessage(error))
      logApiError(error)
    }
  }

  return (
    <AlertDialog open={Boolean(visible)} onOpenChange={open => { if (!open && !removing) handleClose() }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div style={descriptionStyle}>
              <p style={paragraphStyle}>
                Ao remover este profissional da agenda, ele também não aparecerá para os membros da Cutilei.
                Tentaremos realocar novos profissionais para seus agendamentos e avisaremos os clientes.
              </p>
              <p style={paragraphStyle}>
                Caso não haja profissional disponível para substituir {firstName} na data e horário do
                agendamento, avisaremos ao cliente para que o altere.
              </p>
              <p style={paragraphStyle}>
                Você poderá reativar o profissional a qualquer momento na aba de profissionais, em "configurações".
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        {errorMessage && <p role='alert' style={errorStyle}>{errorMessage}</p>}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={removing}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            destructive
            loading={removing}
            onClick={event => {
              // Quem fecha é a resposta da remoção, e não o clique.
              event.preventDefault()
              removeProfessional()
            }}
          >
            Confirmar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
